import StepRoot from './step.root'
import { ActionButton } from '../../../ui/atoms/ActionButton'
import StepContent from './step.content'
import StepButtons from './step.buttons'
import StepButton from './step.button'

export default function Step() {
  return null
}

Step.Root = StepRoot
Step.Content = StepContent
Step.ActionButton = ActionButton
Step.Buttons = StepButtons
Step.Button = StepButton
